export const environment = {
  heading: 'Development',
  production: false,
  apiUrl: 'https://api.dev.gateway.tourboplus.com',
  appUrlTourbohome: 'https://app.dev.tourbohome.tourboplus.com',
  recaptchaV2Key: '6LfcteoqAAAAAB91l4fwcXH82ku6Avnl69K9p0m-',
};
